module.exports = __webpack_public_path__ + "img/gov.d0289dc0.png";